import Repository from './Repository'

const resource = 'results-binomial'

export default {
  getResults (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}`, {
      params: params
    })
  }
}
